export const STANDALONE_ROUTES = ['/coinbase', '/email', '/social'];
